import { FormProvider, type SubmitHandler, useForm } from "react-hook-form";
import YachtSetupSectionHeader from "src/components/pages/Settings/YachtSetUp/YachtSetupSectionHeader";
import Loader from "src/components/shared/Loader/Loader";
import { useCheckPerm, useGetApi, usePostApi } from "src/hooks";
import { useDispatch } from "src/redux/hooks";
import { setPreferences } from "src/redux/slices/preferencesSlice";
import { PageContainer } from "src/styled";
import { Notification } from "src/utils/Notification";

import YachtDetailsForm from "../../../../components/pages/Settings/YachtSetUp/YachtDetailsForm";
import { type IYachtSetupForm } from "./YachtSetup.types";
import { mapYachtSetup } from "./YachtSetup.utils";
import styles from "./YachtSetup.module.scss";

const YachtSetup = () => {
  const { data, isLoading: isGetLoading } = useGetApi({
    request: "get-settings",
    body: { params: { sect: "_particulars" } },
    mapper: mapYachtSetup,
  });
  const { post, isLoading: isPostLoading } = usePostApi();

  const methods = useForm<IYachtSetupForm>({
    values: data,
  });

  const dispatch = useDispatch();
  const checkPerm = useCheckPerm();

  const onSubmit: SubmitHandler<IYachtSetupForm> = async values => {
    const data = { ...values };
    if (data.vtype !== "VT8") {
      data.vtypeother = "";
    }

    await post({
      request: "save-yacht",
      body: { params: data },
      onSuccess: () => {
        methods.reset(data);
        dispatch(setPreferences({ uppercase: data.uppercase }));
        Notification(
          "Success",
          "Yacht details have been successfully changed.",
          "green",
        );
      },
    });
  };

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form
          className={styles.vesselParticularsForm}
          onSubmit={methods.handleSubmit(onSubmit)}>
          <YachtSetupSectionHeader
            isSaving={isPostLoading}
            canSave={checkPerm("editparticulars")}
            section="particulars"
          />
          {!data || isGetLoading ? (
            <Loader />
          ) : (
            <YachtDetailsForm
              type="vessel"
              iomData={
                data.iom && Object.keys(data.iom).length > 0
                  ? data.iom
                  : undefined
              }
            />
          )}
        </form>
      </FormProvider>
    </PageContainer>
  );
};

export default YachtSetup;
